export default {
	'zh-CN': {
		lang: 'zh',
		my: {
			title: '简体中文',
			text: '一切皆有可能',
			cancel:'取消'
		},
		tabBar:{
			home:'首页',
			my:'我的',
			findPark:'找车位'
		}
	},
	'en-US': {
		lang: 'en',
		my: {
			title: '英文',
			text: 'everything is possible',
			cancel:'cancel'
		},
		tabBar:{
			home:'home page',
			my:'mine',
			findPark :'find a spot'
		}
	}	
}